module.exports = __webpack_public_path__ + "b80bb867.png";